import axios from '../../../axiosInstance';
import { jwtDecode } from 'jwt-decode';

export const login = async (credentials) => {
  try {
    const response = await axios.post('/api/auth/login/admin', credentials, { withCredentials: true });
    return response.status === 200;
  } catch (error) {
    console.log('Login failed:', error);
    return false;
  }
};

export const logout = async () => {
  localStorage.clear();

  try {
    const response = await axios.get('/api/auth/logout');
    if (response.status === 200) {
      window.location.href = '/login';
    }
  } catch (error) {
    console.log('Login failed:', error);
    return false;
  }
};

// # TODO: Validate function
// export const getToken = () => {
//   return localStorage.getItem('token');
// };

export const getCurrentUser = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/me`, { withCredentials: true });
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const checkUser = async () => {
  console.log('Checking login status...');
  try {
    const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/auth/check`, { withCredentials: true });
    if (response.status === 200) {
      console.log('id:', response.data.id);
      return response.data.id;
    } else {
      console.log('id: NUlL');
      return null;
    }
  } catch (error) {
    console.log('Auth check failed:', error);
    return null;
  }
};

export const isAuthenticated = async () => {
  try {
    const check = await checkUser();
    if (check === null) {
      // console.log('User is not authenticated');
      return false;
    } else {
      // console.log('User is authenticated');
      // console.log(check, 'user id');
      return true;
    }
  } catch (error) {
    console.log("Error during authentication check:", error);
    return false;
  }
};

// export const isAuthenticated = () => {
  
//    const token = document.cookie.split('; ').find(row => row.startsWith('token'))?.split('=')[1];
//    console.log(document.cookie, " --> token");
//    if (!token) {
//     console.log("Token is undefined or not found");
//     return false;
//    }
  
//    console.log(token, " httpOnly token");
//    return !!token && !isTokenExpired(token);
//   };
  

// export const isAuthenticated = () => {
//   const token = document.cookie.split('; ').find(row => row.startsWith('token'))?.split('=')[1];
//   console.log(token, " httpOnly token");
  
//   return !!token && !isTokenExpired(token);
// };

const isTokenExpired = (token) => {
  const decodedToken = jwtDecode(token);
  return decodedToken.exp * 1000 < Date.now();
};